import { createFileRoute } from '@tanstack/react-router';
import { routeContracts } from '@/app/router/routeContracts';

export const Route = createFileRoute('/legacy-form')({
  component: routeContracts.legacyForm.component,
});
